<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title style="font-size: 13px; margin-left: 10px; text-align: left;" [ngClass]="{'adjustedTitleFont': setting.configuration.uIoptions?.homePageOption == 10}">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="false" [ngClass]="{'disable-background-color': !this.setting.UIshowBackground}">
  <auth-login [fromDesktopCheckout]="fromDesktopCheckout" (onLogin)="onLogin()" (onForgotPasswordClicked)="onForgotPasswordClicked()"></auth-login>
</ion-content>